import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./index.css";
import "../src/Pacifico-Regular.ttf";
import "../src/Quicksand-VariableFont_wght.ttf";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Header from "./components/header";
import Fave from './components/fave';
import Business from './components/business';
import Archive from './components/archive';
import How from './components/how';
import Criteria from "./components/criteria";
import Search from "./components/search";
import Policy from "./components/policy";
import AppPromptModal from "./components/appPromptModal";

const APP_PROMPT_SEEN_KEY = "iwk_app_prompt_seen";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return null;
}

function AppShell() {
  const [isAppPromptOpen, setIsAppPromptOpen] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }
    if (!window.localStorage.getItem(APP_PROMPT_SEEN_KEY)) {
      setIsAppPromptOpen(true);
    }
  }, []);

  const closeAppPrompt = () => {
    if (typeof window !== "undefined") {
      window.localStorage.setItem(APP_PROMPT_SEEN_KEY, "true");
    }
    setIsAppPromptOpen(false);
  };

  return (
    <>
      <ScrollToTop />
      <Header />
      <App />
      <Routes>
        <Route path="/" element={<Navigate to="/fave" />} />
        <Route path="/fave" element={<Fave />} />
        <Route path="/archive" element={<Archive />} />
        <Route path="/business/:ticker" element={<Business />} />
        <Route path="/how" element={<How />} />
        <Route path="/criteria" element={<Criteria />} />
        <Route path="/search" element={<Search />} />
        <Route path="/subscribe" element={<Navigate to="/fave" replace />} />
        <Route path="/policy" element={<Policy />} />
      </Routes>
      <AppPromptModal isOpen={isAppPromptOpen} onClose={closeAppPrompt} />
    </>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <AppShell />
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
